module.exports = __webpack_public_path__ + "static/media/12UNCTAD15.6e5170f3.jpg";